import { render } from "./transscriptOneServerComponent.vue?vue&type=template&id=7988af2c&scoped=true"
import script from "./transscriptOneServerComponent.vue?vue&type=script&lang=js"
export * from "./transscriptOneServerComponent.vue?vue&type=script&lang=js"

import "./transscriptOneServerComponent.vue?vue&type=style&index=0&id=7988af2c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Agile-bot-web-dashboard/Agile-bot-web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7988af2c"]])

export default __exports__